// src/stone/icons/File2X.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var File2X = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 40 40",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M6.936 3.603A4.33 4.33 0 0 1 10 2.333h11.667a1 1 0 0 1 .707.293L34.04 14.293a1 1 0 0 1 .292.707v18.333A4.333 4.333 0 0 1 30 37.667H10a4.333 4.333 0 0 1-4.333-4.334V6.667c0-1.15.456-2.252 1.269-3.064m3.064.73a2.333 2.333 0 0 0-2.333 2.334v26.666A2.333 2.333 0 0 0 10 35.667h20a2.333 2.333 0 0 0 2.333-2.334V15.414l-11.08-11.08z" }),
      /* @__PURE__ */ jsx("path", { d: "M21.667 2.333a1 1 0 0 1 1 1V14h10.666a1 1 0 0 1 0 2H21.667a1 1 0 0 1-1-1V3.333a1 1 0 0 1 1-1" })
    ]
  }
);
var File2X_default = File2X;

export {
  File2X_default
};
